// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__156dU","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__R4j1L"};